import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import StartGameFlowLayout from "../components/StartGameFlowLayout";
import { ROUTES } from "../utils/constants";
import { setLastTickNow, updateStats, updateTimer } from "../utils/helpers";
import { fetchGameIfPlayAllowed } from "../utils/gamePlayGuard";
import reglas3 from "../assets/avatares/reglas-3.mp4";

export default function GameIntroduction() {
	const navigate = useNavigate();
	const game = useSelector((state) => state.game);
	const group = useSelector((state) => state.group);
	const [loading, setLoading] = useState(false);

	const handleNext = () => {
		if (loading) return;
		setLoading(true);
		void fetchGameIfPlayAllowed(game?._id)
			.then(({ ok }) => {
				if (!ok) {
					setLoading(false);
					return;
				}
				const t0 = 0;
				updateTimer(t0);
				setLastTickNow();
				updateStats({
					...group,
					actualScenario: 2,
					time: t0,
					lastVisited: ROUTES.TRANSITION_SCENARIOS,
				});
				navigate(ROUTES.TRANSITION_SCENARIOS, {
					state: { activeScenario: 2 },
				});
				setLoading(false);
			})
			.catch(() => setLoading(false));
	};

	return (
		<StartGameFlowLayout
			brandTheme
			sidebarTitle="Reglas Dinámica III"
			loading={loading}
			onContinue={handleNext}
			video={reglas3}
		>
			<div className="start-game-rule-block">
				<h3>Tiempo limitado</h3>
				<p>
					Tenéis <span className="start-game-mark-ok">30 minutos</span> para completar la dinámica.
					<br />
					Durante ese tiempo deberéis analizar la situación, responder a los retos planteados y tomar las decisiones que consideréis más adecuadas.
				</p>
			</div>
			<div className="start-game-rule-block">
				<h3>Atención</h3>
				<p>
					No está permitido manipular material que no esté identificado como parte del juego.
					<br />
					Seguid únicamente las instrucciones que aparezcan en la tablet o que sean indicadas por la organización.
				</p>
			</div>
			<div className="start-game-rule-block start-game-rule-block--emphasis">
				<h3>Recuerda</h3>
				<p>
					No se trata solo de responder rápido, sino de demostrar criterio profesional.
					<br />
					Cada decisión debe reflejar capacidad de análisis, trabajo en equipo, priorización de riesgos y una integración de la inteligencia artificial útil, segura, ética y responsable.
				</p>
			</div>
		</StartGameFlowLayout>
	);
}
